var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 1.4002C2.4 2.06294 1.86274 2.6002 1.2 2.6002C0.537258 2.6002 0 2.06294 0 1.4002C0 0.737454 0.537258 0.200195 1.2 0.200195C1.86274 0.200195 2.4 0.737454 2.4 1.4002ZM2.4 5.0002C2.4 5.66294 1.86274 6.2002 1.2 6.2002C0.537258 6.2002 0 5.66294 0 5.0002C0 4.33745 0.537258 3.8002 1.2 3.8002C1.86274 3.8002 2.4 4.33745 2.4 5.0002ZM1.2 9.8002C1.86274 9.8002 2.4 9.26294 2.4 8.60019C2.4 7.93745 1.86274 7.4002 1.2 7.4002C0.537258 7.4002 0 7.93745 0 8.60019C0 9.26294 0.537258 9.8002 1.2 9.8002Z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59998 1.20019C3.59998 0.64791 4.04769 0.200195 4.59998 0.200195H11C11.5523 0.200195 12 0.647911 12 1.2002V1.6002C12 2.15248 11.5523 2.6002 11 2.6002H4.59998C4.04769 2.6002 3.59998 2.15248 3.59998 1.6002V1.20019ZM3.6 4.80019C3.6 4.24791 4.04772 3.8002 4.6 3.8002H11C11.5523 3.8002 12 4.24791 12 4.8002V5.2002C12 5.75248 11.5523 6.2002 11 6.2002H4.6C4.04772 6.2002 3.6 5.75248 3.6 5.2002V4.80019ZM4.6 7.4002C4.04772 7.4002 3.6 7.84791 3.6 8.40019V8.80019C3.6 9.35248 4.04772 9.8002 4.6 9.8002H11C11.5523 9.8002 12 9.35248 12 8.8002V8.4002C12 7.84791 11.5523 7.4002 11 7.4002H4.6Z",
    fill: "#A1A5B7",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.f0c7c782af687139296c5914f1e05881.svg";
export { ForwardRef as ReactComponent };